import { render, staticRenderFns } from "./AppAlerts.vue?vue&type=template&id=2d9d625e&scoped=true"
import script from "./AppAlerts.vue?vue&type=script&lang=js"
export * from "./AppAlerts.vue?vue&type=script&lang=js"
import style0 from "./AppAlerts.vue?vue&type=style&index=0&id=2d9d625e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d625e",
  null
  
)

export default component.exports